import { defineComponent, SVGAttributes } from "vue";

  export const SvgStatusDraft = defineComponent<SVGAttributes>({
    setup() {
      return () => <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m4.79376 9.74365 1.40624 1.40629-.5625.5625h-.61876v-.7875h-.78748v-.61878zm11.2063-1.74371a8.00006 8.00006 0 1 1 -8.00012-8 8.00006 8.00006 0 0 1 8.00012 8zm-5.07506-.45-2.475-2.475-4.95 4.95v2.475h2.475zm1.575-1.91249a1.344 1.344 0 0 0 -.11249-.50628l-1.40625-1.40623a.81568.81568 0 0 0 -1.125 0l-1.01251.95623 2.41876 2.53125 1.01249-1.01248a.72234.72234 0 0 0 .225-.56249z"/></svg>;
    },
  });